import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CustomLink from '@shared/components/customLink'
import { getMatchPlayers } from '@shared/libs/match-detail'
import { DownArrow } from '@shared/components/ctIcons'
import styles from './style.module.scss'
import BowlerOvers from '../bowlerOvers'
import { useLazyQuery } from '@apollo/client'
import { GET_BOWLER_STATS_SCORECARD } from '@graphql/match/match.query'
import MyImage from '@shared/components/myImage'
import { getImgURL } from '@shared-submodule/utils'
import playerPlaceholder from '@assets/images/placeholder/Placeholder_Player.svg'
import dynamic from 'next/dynamic'
const NoData = dynamic(() => import('@shared/components/noData'), { ssr: false })

export default function BowlerDataRow({ bowler, table, matchDetail, currentTeam }) {
  const [downDown, setDropdown] = useState(false)
  const players = getMatchPlayers()
  const b = players[bowler?.iBowlerId] || bowler?.oBowler
  const playerSlug = b?.oSeo?.sSlug

  const isCaptain = bowler?.oBowler?.isCaptain ? '( c )' : ''
  const isWk = bowler?.oBowler?.isWk ? '(wk)' : ''
  const isCandW = bowler?.oBowler?.isCaptain && bowler?.oBowler?.isWk ? '(c & wk)' : ''

  const [getPlayerStats, { data: playerStats, loading }] = useLazyQuery(GET_BOWLER_STATS_SCORECARD)

  function handleDropdown() {
    setDropdown(prev => !prev)
    getPlayerStats({
      variables: {
        input: {
          iMatchId: matchDetail?._id,
          iPlayerId: bowler?.iBowlerId
        }
      }
    })
  }

  const aStats = playerStats?.getPlayerMatchStats?.oPlayerMatchStats?.aStats || []
  const currentStats = aStats?.find(stat => stat?.nInningNumber === currentTeam && stat?.oBowlStats !== null)
  const overs = currentStats?.oBowlStats?.aOvers || []

  return (
    <>
      <tr className={`${bowler.highlight && 'highlight'}`}>
        <td>
          <div className="d-flex flex-column flex-md-row">
            <div className={`${styles.batterName} d-flex ${bowler?.eDismissal === null ? 'orig-theme' : ''}`}>
              {downDown && (
                <div className={styles.batterImage}>
                  <MyImage
                    src={getImgURL(playerStats?.getPlayerMatchStats?.oPlayerMatchStats?.oPlayer?.oImg?.sUrl)}
                    height={35}
                    width={35}
                    placeholderImage={playerPlaceholder}
                  />
                </div>
              )}
              <div>
                <div className="d-flex align-items-center">
                  <p onClick={() => setDropdown(prev => !prev)} className="cursor-pointer">
                    {b?.sFullName || b?.sShortName || '-'}
                    <span className="mx-1">{isCandW || `${isCaptain} ${isWk}`}</span>
                  </p>

                  {!downDown && (
                    <p
                      onClick={handleDropdown}
                      className={`mx-2 mb-0 ${downDown ? styles.rotate_arrow : styles.rotate_arrow_reverse} cursor-pointer`}>
                      <DownArrow />
                    </p>
                  )}
                </div>
                {downDown && b?.eTagStatus === 'a' && (
                  <CustomLink href={`/${playerSlug}`} prefetch={false}>
                    <a>
                      <p className="text-theme-color mb-0">Open Profile</p>
                    </a>
                  </CustomLink>
                )}
              </div>
            </div>
          </div>
        </td>

        {!downDown &&
          Object.keys(table)?.map(value => {
            return <td key={value}>{bowler[value]}</td>
          })}

        {downDown && (
          <td colSpan={7} style={{ verticalAlign: 'middle' }}>
            <p onClick={() => setDropdown(prev => !prev)} className={`d-inline ${styles.closeBtn}`}>
              Close
            </p>
          </td>
        )}
      </tr>

      {(downDown && !playerStats?.getPlayerMatchStats?.oPlayerMatchStats?.isDataFlag && !loading) && (
        <tr>
          <td colSpan={8} className="p-0">
            <div className="d-flex justify-content-center align-items-center w-100">
              <NoData className="w-100" />
            </div>
          </td>
        </tr>
      )}

      {(downDown && playerStats?.getPlayerMatchStats?.oPlayerMatchStats?.isDataFlag && currentStats) && (
        <tr>
          <td colSpan={8} className="p-0">
            {overs.map((item, i) => {
              const isLast = i === overs.length - 1
              return (
                <div key={`${item?.sOver}-${i}`} className={!isLast ? styles.borderBottom : ''}>
                  <BowlerOvers playerData={item} />
                </div>
              )
            })}
          </td>
        </tr>
      )}
    </>
  )
}

BowlerDataRow.propTypes = {
  players: PropTypes.object,
  bowler: PropTypes.object,
  matchDetail: PropTypes.object,
  table: PropTypes.object,
  currentTeam: PropTypes.number
}
